/**
 * Created by Roman on 2015-02-26.
 */


angular
    .module('flipto.components.common.dateRange', ['flipto.core.storage']);